import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 py-4'
      }`}
    >
      <div className="container mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 brand-font">AutoRust Pro</h1>
            <p className="text-xs text-gray-600">Rust Repair & Undercoating</p>
          </div>
        </div>
        <nav className="hidden md:flex items-center gap-8">
          <a href="#" className="text-gray-700 hover:text-amber-600 font-medium transition-colors duration-200">Home</a>
          <a href="#services" className="text-gray-700 hover:text-amber-600 font-medium transition-colors duration-200">Services</a>
          <a href="#contact" className="text-gray-700 hover:text-amber-600 font-medium transition-colors duration-200">Contact</a>
        </nav>
        <Button 
          className="bg-amber-500 hover:bg-amber-600 text-black font-semibold transition-all duration-300 transform hover:scale-105"
          onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
        >
          <Phone className="w-4 h-4 mr-2" />
          Call Now
        </Button>
      </div>
    </header>
  );
};

export default Header;